import Vue from "vue";

import orderBy from "lodash.orderby";
import unionby from "lodash.unionby";

Vue.prototype.$unionby = unionby;

Vue.prototype.$orderBy = orderBy;
